import React from 'react';
import { motion } from 'framer-motion';

const SectionHeading = ({ headline, subheadline, align = 'center', className = '' }) => {
  const aligns = {
    left: 'text-left',
    center: 'text-center mx-auto',
    right: 'text-right ml-auto'
  };

  return (
    <div className={`max-w-4xl mb-12 md:mb-16 ${aligns[align]} ${className}`}>
      <motion.h2 
        initial={{ opacity: 0, y: 20 }} 
        whileInView={{ opacity: 1, y: 0 }} 
        viewport={{ once: true }} 
        className="text-3xl md:text-5xl lg:text-6xl font-bold mb-6 text-white tracking-tight leading-[1.1]"
      > 
        {headline} 
      </motion.h2>
      {subheadline && (
        <motion.p 
          initial={{ opacity: 0, y: 20 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }} 
          transition={{ delay: 0.1 }}
          className="text-base md:text-xl text-slate-400 leading-relaxed max-w-3xl mx-auto"
        > 
          {subheadline} 
        </motion.p>
      )}
    </div>
  );
};

export default SectionHeading;